import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { openModalAction } from '../../actions/modal';
import { getCurrentRole, getSwitchableRoles } from '../../actions/auth';
import { ROLE_SWITCHER_MODAL_NAME } from '../../modals/RoleSwitcherModal';
import Strings from '../../Strings';

import './RoleSwitcherButton.scss';

function RoleSwitcherButton(props) {
  const {
    visible,
    switchableRoles,
    currentRole,
    originalRole,
    fetchSwitchable,
    fetchCurrentRole,
    openRoleSwitcher,
  } = props;

  // Fetch mode and current role on mount
  useEffect(() => {
    fetchSwitchable();
    fetchCurrentRole();
  }, []);

  // Don't render if mode is 'none' or not yet loaded
  if (!switchableRoles || switchableRoles.length === 0) {
    return null;
  }

  const isNativeRole = currentRole && originalRole
    ? currentRole.role_uuid === originalRole.role_uuid && currentRole.org_uuid === originalRole.org_uuid
    : true;

  const handleClick = () => {
    openRoleSwitcher();
  };

  if (!visible) {
    // Collapsed state - just show an icon
    return (
      <button
        type="button"
        className="role-switcher-button collapsed"
        onClick={handleClick}
        title={Strings.roleSwitcher?.title || 'Switch Role'}
      >
        <span className="role-icon" />
        {!isNativeRole && <span className="switched-indicator" />}
      </button>
    );
  }

  return (
    <button
      type="button"
      className="role-switcher-button"
      onClick={handleClick}
      data-testid="role-switcher-button"
    >
      <div className="role-info">
        <span className="role-title">
          {currentRole?.role_title || Strings.roleSwitcher?.defaultRole || 'Role'}
        </span>
        {currentRole?.org_name && (
          <span className="org-name">@ {currentRole.org_name}</span>
        )}
      </div>
      {!isNativeRole && (
        <span className="switched-badge">{Strings.roleSwitcher?.switched || 'Switched'}</span>
      )}
      <span className="switch-icon" />
    </button>
  );
}

RoleSwitcherButton.propTypes = {
  visible: PropTypes.bool,
  switchableRoles: PropTypes.arrayOf(PropTypes.shape({
    role_uuid: PropTypes.string,
    role_title: PropTypes.string,
    org_uuid: PropTypes.string,
    org_name: PropTypes.string,
    facility_uuid: PropTypes.string,
    facility_name: PropTypes.string,
  })),
  currentRole: PropTypes.shape({
    role_uuid: PropTypes.string,
    role_title: PropTypes.string,
    org_uuid: PropTypes.string,
    org_name: PropTypes.string,
  }),
  originalRole: PropTypes.shape({
    role_uuid: PropTypes.string,
    org_uuid: PropTypes.string,
  }),
  fetchSwitchable: PropTypes.func.isRequired,
  fetchCurrentRole: PropTypes.func.isRequired,
  openRoleSwitcher: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  switchableRoles: state.auth.switchableRoles,
  currentRole: state.auth.currentRole,
  originalRole: state.auth.originalRole,
});

const mapDispatchToProps = dispatch => ({
  fetchSwitchable: () => dispatch(getSwitchableRoles()),
  fetchCurrentRole: () => dispatch(getCurrentRole()),
  openRoleSwitcher: () => dispatch(openModalAction(ROLE_SWITCHER_MODAL_NAME)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleSwitcherButton);
